import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const Spinner = ({ sx, progressProps, ...props }) => (
  <Box
    sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', ...sx }}
    {...props}
  >
    <CircularProgress {...progressProps} />
  </Box>
)

export default Spinner
